export const isReachedLimitExcelRows = (rowsCount: number) => rowsCount > 34000;
